import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import BerthService from "../../../../services/catalogs/BerthService";

export const REQUEST_DELETE_BERTH = "REQUEST_DELETE_BERTH";
export const DELETE_BERTH_SUCCESS = "DELETE_BERTH_SUCCESS";
export const DELETE_BERTH_ERROR = "DELETE_BERTH_ERROR";

function requestDeleteBerth() {
  return {
    type: REQUEST_DELETE_BERTH,
  };
}

function deleteBerthSuccess(json) {
  return {
    type: DELETE_BERTH_SUCCESS,
    message: json.data,
  };
}

function deleteBerthError(json) {
  return {
    type: DELETE_BERTH_ERROR,
    error: json.data,
  };
}

export function deleteBerth(berth_id) {
  return (dispatch) => {
    dispatch(requestDeleteBerth());
    return BerthService.deleteBerth(berth_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(deleteBerthSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteBerth(berth_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(deleteBerthError(json.data));
      }
    });
  };
}
